import { render, staticRenderFns } from "./SideMenuMobile.vue?vue&type=template&id=60f11c52"
import script from "./SideMenuMobile.vue?vue&type=script&lang=js"
export * from "./SideMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./SideMenuMobile.vue?vue&type=style&index=0&id=60f11c52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports